module.exports = __webpack_public_path__ + "img/14-l.be7b98d9.png";